<!-- =========================================================================================
  File Name: View.vue
  Description: Partner View page
========================================================================================== -->

<template>
  <div id="page-partner-view">

    <vs-alert color="danger" title="Партнер не найден" :active.sync="partner_not_found">
      <span>Партнер с идентификатором: {{ $route.params.partnerId }} не найден. </span>
      <span>
        <span>Перейти в </span><router-link :to="{name:'apps-partners-list'}" class="text-inherit underline">список партнеров</router-link>
      </span>
    </vs-alert>

    <div id="partner-data" v-if="!partner_not_found">

      <vx-card title="Информация" class="mb-base">

        <!-- Logo -->
        <div class="vx-row">

          <!-- Logo Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="'/img/avatar-s-3.7ed1da4a.jpg'" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Компания</td>
                <td>{{ partner_data.company || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Программа</td>
                <td>{{ programLocal.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Статус</td>
                <td>
                  <vs-chip class="status-chip" :color="statusColor(partner_data.state)">
                    <span>{{ statusText(partner_data.state) }}</span>
                  </vs-chip>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Имя</td>
                <td>{{ partner_data.fname || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Фамилия</td>
                <td>{{ partner_data.lname || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Должность</td>
                <td>{{ partner_data.position || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время создания</td>
                <td>{{ partner_data.time || '-' }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">

            <vs-button icon-pack="feather" icon="icon-list" class="mr-4" :to="{name: 'apps-partners-list'}">Назад к списку</vs-button>

            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" class="mr-4" @click="confirmDeleteRecord">Удалить</vs-button>

            <vs-button type="border" color="success" icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'apps-partners-edit', params: { partnerId: $route.params.partnerId }}">Редактировать</vs-button>

          </div>

        </div>

      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Контакты" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Адрес</td>
                <td>{{ partner_data.address || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время работы</td>
                <td>{{ partner_data.worktime || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Телефон</td>
                <td>{{ partner_data.phone || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Web-сайт</td>
                <td>{{ partner_data.website || '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">E-mail</td>
                <td>{{ partner_data.email || '-' }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Описание" class="mb-base">
            {{ partner_data.descr }}
          </vx-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import modulePartner from '@/store/partner/modulePartner.js'

export default {
  data() {
    return {
      partner_not_found: false,
    }
  },
  computed: {
    partner_data() {
      return this.$store.state.partner.partner
    },
    statusColor() {
      return (value) => {
        if (typeof value !== 'undefined') {
          return modulePartner.partnerStateList[value].color
        }
        return ""
      }
    },
    statusText() {
      return (value) => {
        if (typeof value !== 'undefined') {
          return modulePartner.partnerStateList[value].label
        }
        return ""
      }
    },
    programLocal() {
      return this.$store.getters["partner/getProgram"](this.partner_data.program) ? this.$store.getters["partner/getProgram"](this.partner_data.program) : { name: '...' }
    },
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Удаление партнера`,
        text: `Вы действительно хотите удалить партнера ${this.partner_data.company} (${this.partner_data.lname} ${this.partner_data.fname})?`,
        accept: this.deleteRecord,
        acceptText: "Удалить",
        cancelText: "Отмена"
      })
    },
    deleteRecord() {
      this.$store.dispatch("partner/deletePartner", this.partner_data)
        .then(() => { this.$router.push({name:'apps-partners-list'}); })
    },
  },
  created() {
    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }
    
    this.$store.dispatch("partner/fetchPartner", { partid: this.$route.params.partnerId })
      .then(() => {
        this.partner_not_found = !this.partner_data.partid
      })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

.status-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}

#page-partner-view {
  table {
    td {
      vertical-align: top;
      min-width: 120px;
      padding-bottom: .8rem;
      word-break: break-all;
      padding-right: 10px;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}

</style>
